import { useMemo } from "react";
import type {
  BaseFilter,
  RenderFilter,
} from "@circle-react-shared/MemberFilters/types";

export const usePickFilters = ({
  allFilters,
  selectedFilters,
}: {
  allFilters: RenderFilter[];
  selectedFilters: BaseFilter[];
}) =>
  useMemo(() => {
    const keysToBePicked = [
      ...allFilters.map(({ name }) => name),
      "profile_field",
      "geo_location",
      "near_me",
    ];
    return selectedFilters.filter(filterParam =>
      keysToBePicked.includes(filterParam.key),
    );
  }, [allFilters, selectedFilters]);
